/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-undef */
import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import { motion } from 'framer-motion'
import { Link, useLocation, useParams, useSearchParams } from "react-router-dom"
import TopHeader from '../../../../components/TopHeader'
import CustomOverLay from '../../../../components/CustomOverLay'
import { useExportPatientWellnessNotesMutation, useListWellnessNotesQuery,useGetHelpGuidePatientQuery } from '../../../../features/patientSlice'
import GlobalContext from '../../../../components/Context/GloablContext'
import SearchEmptyScreen from '../../../../components/SearchEmptyScreen'
import { convertEpochToDateFormat } from '../../../../CommonMethods/DateConversion'
import { useDispatch, useSelector } from 'react-redux'
// import Emptyscreen from '../../../../../components/EmptyScreen'
import { handleAddFilterValues,resetFilterState } from '../../../../redux/systemConfigSlice'
import FilterObserverBtn from '../ManagePatientVitalHistory/Components/Filter'
import { convertDatesToEpochUTC } from '../../../../CommonMethods/ConvertFilterDatetoEpochUtcFormat'
import Emptyscreenwithouttitle from '../../../../components/Emptyscreenwithouttitle'
import HelpGuideModal from '../../../../components/HelpGuideModal'


const ContactHistory = () => {
    const location = useLocation()
    // const navigate = useNavigate()
    const { id, patientId } = useParams()
    const dispatch = useDispatch()
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const filtervals = useSelector(state => state.systemConfigData.filterState)
    const { isSideBar, setToastmessage, setToastErrorMessage, } = useContext(GlobalContext)

    const [exportNotes] = useExportPatientWellnessNotesMutation()
    const [exportLoading, setExportLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams({})

    let queryObject = {
        id: patientId
    };
    if (searchParams) {
        const params = Object.fromEntries(searchParams);
        
        queryObject.body = {
            ...params
        };
    }
    const { data, isFetching, status } = useListWellnessNotesQuery(
        queryObject,
        { refetchOnMountOrArgChange: true }
    );
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const auth=useSelector(state=>state?.auth)
    const {userType} = auth
    const [queryParams, setQueryParams] = useState('')
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const { data: helpguidedata,status: helpguidestatus  } = useGetHelpGuidePatientQuery(queryParams, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    

    const [dateError, setdateError] = useState(false)
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const initialState = {
        "filter_start_date": '',
        "filter_end_date": '',
    }
    const [filterValues, setFilterValues] = useState(initialState);

    const [collapsedNotes, setCollapsedNotes] = useState([]);

    useEffect(() => {
        if (status === "fulfilled" && data?.patientData) {
            // Initialize collapsedNotes based on the condition
            const initialCollapsedState = data.patientData.map((_, index) => index !== 0);
            setCollapsedNotes(initialCollapsedState);
        }
    }, [status, data]);

    const handleCollapseToggle = (index) => {
        setCollapsedNotes(prev => {
            const newCollapsedNotes = [...prev];
            newCollapsedNotes[index] = !newCollapsedNotes[index];
            return newCollapsedNotes;
        });
    };


    useEffect(() => {
        if (queryParams) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParams]);

    useEffect(() => {
        const adjustTextareaHeight = () => {
            const textareas = document.querySelectorAll('.auto-height-textarea');

            textareas.forEach((textarea) => {
                textarea.style.height = 'auto';
                textarea.style.height = `${textarea.scrollHeight}px`;
            });
        };
        // Call the adjustTextareaHeight function after the initial render
        adjustTextareaHeight();

        // Attach the adjustTextareaHeight function to the resize event to handle dynamic content changes
        window.addEventListener('resize', adjustTextareaHeight);
        // Clean up the event listener to prevent memory leaks
        return () => {
            window.removeEventListener('resize', adjustTextareaHeight);
        };
    }, [data && data.patientData, collapsedNotes]);



    async function handleExport(type, patientId) {
        let noteType = type;
        setExportLoading(true);
        const params = Object.fromEntries(searchParams);
  
        // Define default payload with query parameters
        let payload = {
            patientId,
            dateformat,
            noteType,
        };
        // Check if either start_date or end_date is not empty
        if (params.start_date || params.end_date) {
            payload.filter = 'true';
            // Assuming you have these predefined
            payload.start_date = params.start_date;
            payload.end_date = params.end_date;
        }


        
        const exportRes = await exportNotes(payload);
        setExportLoading(false);
        window.open(exportRes?.data.presigned_url);

        if (exportRes?.error) {
            setToastErrorMessage("Something went wrong");
        } else {
            setToastmessage(exportRes?.data?.message);
        }
    }




    const user_type_labels = {
        "admin-user": "Admin",
        "super-admin": "Super Admin",
        "corporate-user": "Corporate",
        "organization-user": "Organization User",
        "provider": "Provider",
        "observer": "Observer",
        "monitor-user": "Monitor"
    }


    const handleApplyFilter = (type) => {
        let params = { ...Object.fromEntries(searchParams) };
        const start_date = moment(filterValues.filter_start_date).format('YYYY-MM-DD');
        const end_date = moment(filterValues.filter_end_date).format('YYYY-MM-DD');

        const filterValuesToDispatch = {};

        if (filterValues.filter_start_date) {
            filterValuesToDispatch["filter_start_date"] = filterValues.filter_start_date;
        }

        if (filterValues.filter_end_date) {
            filterValuesToDispatch["filter_end_date"] = filterValues.filter_end_date;
        }


        if (type) {
            const startDateEpoch = filterValues.filter_start_date !== "" ? convertDatesToEpochUTC(start_date, 'UTC', true) : undefined
            const endDateEpoch = filterValues.filter_end_date !== "" ? convertDatesToEpochUTC(end_date, 'UTC', false) : undefined

            const updatedParams = {
                filter: "true",
                ...(startDateEpoch && { start_date: startDateEpoch }),
                ...(endDateEpoch && { end_date: endDateEpoch }),
            };
            setSearchParams(updatedParams);

        }else {
            // Preserve the search parameter and remove only the filter-related parameters
            delete params['start_date'];
            delete params['end_date'];
            setSearchParams(params);
        }
        
        // Dispatch filter values regardless of the 'type'
        dispatch(handleAddFilterValues(filterValuesToDispatch));
        

    };

    useEffect(() => {
        if (searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
            dispatch(resetFilterState())
        }
    }, [searchParams])


    const handleClearFilter = () => {
        let params = Object.fromEntries(searchParams);
        delete params.end_date
        delete params.start_date
        setSearchParams({ ...params })
    }


    const handleOpenFilter = () => {
        setdateError(false)
        // Check for monitor_list, status, filter_start_date, and filter_end_date
        if ((searchParams.get("monitor_list") !== null || searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
            setFilterValues((prevFilterValues) => ({
                ...prevFilterValues,
                "filter_start_date": filtervals.filter_start_date,
                "filter_end_date": filtervals.filter_end_date,
            }));

        } else if ( searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
            setFilterValues({
                "filter_start_date": '',
                "filter_end_date": '',
            });
        }
        setIsFilterOpen(!isFilterOpen);
    };

    const ApplyFilter = (data === undefined) ? false : true

    useEffect(() => {
        if (userType === 'patient-user') {
          setQueryParams('type=patients-wellness-contact-history');
        } else {
          setQueryParams('type=observers-wellness-contact-history');
        }
      }, [userType]);



    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Dashboard"} />
                {/* isFetching&&status!=="fulfilled" */}
                {isFetching && status !== "fulfilled" ? <CustomOverLay Active text="Loading Wellness Contact History..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> : status === "rejected" ? <SearchEmptyScreen text={"No data found"} /> : <>
                    <div className='bg-white rounded-lg py-[12px] px-[30px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='flex items-center mb-[22px]'>
                                    <Link to="/dashboard" state={Array.isArray(location.state) ? '' : location.state}>
                                        <h1 className="text-sm font-normal text-[#52555D]">Dashboard</h1>
                                    </Link>
                                    <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                    <Link to={`/dashboard/view-details/${id}`}>
                                        <h1 className="text-sm font-normal text-[#52555D]">View Details</h1>
                                    </Link>
                                    <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                    <h1 className="text-sm font-normal text-[#008586]">Wellness Contact History</h1>
                                 
                                </div>
                                <div className="flex items-center w-full pb-4 pr-4">
                                    <Link to={`/dashboard/view-details/${id}`} state={Array.isArray(location.state) ? '' : location.state} className='flex items-center min-w-max z-[99]'>
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to View Details</span>
                                    </Link>
                                </div>
                            </div>
                            <div className='2xl:px-[60px] xl:px-5'>
                                <div className='mt-4 flex justify-between relative items-center'>
                                    <div className='flex items-center'>
                                    <p className='text-xl font-semibold text-[#000000]'>Wellness Contact History</p>
                                    <span onClick={() => setHelpGuideModel(true)} className='ml-2 cursor-pointer'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span>

                                    </div>
                                    
                                    <div className='flex justify-end'>
                                        {(ApplyFilter !== undefined && ApplyFilter) &&
                                            <FilterObserverBtn
                                                dateError={dateError}
                                                setdateError={setdateError}
                                                isFilterOpen={isFilterOpen}
                                                setIsFilterOpen={setIsFilterOpen}
                                                handleApplyFilter={handleApplyFilter}
                                                filterValues={filterValues}
                                                setFilterValues={setFilterValues}
                                                initialState={initialState}
                                                // setIsAnyFieldFilled={setIsAnyFieldFilled}
                                                handleClearFilter={handleClearFilter}
                                                // isPatient={isPatient}
                                                handleOpenFilter={handleOpenFilter}
                                            />
                                        }
                                        {(data.patientData.length !== 0) &&
                                            <button id="icon-export" disabled={exportLoading} onClick={() => handleExport("wellness-note", patientId)} className="border border-[#972E4C] rounded-[15px] px-[15px] py-[12px] disabled:cursor-not-allowed ml-4">
                                                {exportLoading ?
                                                    <div className='flex justify-center items-center'>
                                                        <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-5 w-5 spin-animation"></div>
                                                    </div>
                                                    : <img src="/images/download-red.svg" alt="download-icon" />}
                                            </button>
                                        }
                                    </div>
                                </div>
                                <div>
                                    {data.patientData.length > 0 ? (
                                        <>
                                            <div className='flex  justify-end'>
                                                <div className='flex  pt-5 pb-2.5 left-0 z-30 justify-end'>
                                                    <button type='button' id='collapse_all' className='text-[16px] text-[#008586] leading-normal font-normal'>
                                                        <span className='cursor-pointer' onClick={() => setCollapsedNotes(new Array(data.patientData.length).fill(true))}>Collapse All</span>
                                                    </button>
                                                    <button type='button' id='expand_all' className='pl-[16px] text-[16px] text-[#008586]  leading-normal font-normal'>
                                                        <span className='cursor-pointer' onClick={() => setCollapsedNotes(new Array(data.patientData.length).fill(false))}>Expand All</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='h-[calc(100vh-344px)] scrollbar_purpleThin pr-4 overflow-x-hidden'>                                    
                                                {data?.patientData.map((note, index) => (
                                                    <div key={index}>
                                                        <div className='bg-[#E5F3F3] w-full items-center py-2 rounded-[4px] mt-[7px] flex px-4 cursor-pointer' onClick={() => handleCollapseToggle(index)}>
                                                            <p className='text-[18px] text-[#000] font-normal leading-normal'>
                                                                {note.last_name}{note?.last_name ? ',' : ''} <span className='pl-1'>{note.first_name}</span> <span className='pl-1'>({user_type_labels[note.user_type] || note.user_type})</span><span className='pl-2'>{note.user_id}</span>
                                                            </p>
                                                            <p className='text-[14px] pl-[24px] text-[#52555D] font-normal leading-normal'>{convertEpochToDateFormat(note.updated_at, dateformat)} {(note.end_time)}</p>
                                                            <img className={`ml-auto cursor-pointer rotate ${!collapsedNotes[index] ? "rotate-180" : 'rotate-0'}`} src="/images/collapse.svg" alt="collapse" />
                                                        </div>
                                                        {!collapsedNotes[index] && (
                                                            <textarea
                                                                id={'added_notes'}
                                                                readOnly
                                                                value={note.description}
                                                                className='text-[16px] py-2 text-[#000000] font-normal w-full outline-0 resize-none auto-height-textarea text-justify'
                                                            />
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </>)
                                        :
                                        <>
                                            {data?.patientData?.length === 0 && (searchParams.get("start_date") !== null || searchParams.get("end_date") !== null || searchParams.get("monitor_list") !== null) ?
                                                <SearchEmptyScreen welnesscontact={true} text={"That filter combination has no result. Please try different criteria"} />
                                                :
                                                data?.patientData.length === 0 ?
                                                    <Emptyscreenwithouttitle
                                                        ViewNotes={true}
                                                        PatientNotes={true}
                                                        title={"Manage Patients"}
                                                        FirstPTag={"No Wellness notes to view yet."}
                                                    />
                                                    : ((status === "rejected" || (data?.total_count !== 0 && data?.data?.length === 0)) && <SearchEmptyScreen text={"No data found"} />)
                                            }
                                        </>
                                    }
                                </div>
                                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                                <HelpGuideModal
                                    setHelpGuideModel={setHelpGuideModel}
                                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                                />
                            }
                            </div>
                        </motion.div>
                    </div>
                </>}
            </div>
        </>
    )
}

export default ContactHistory